import moment from "moment";

const currentDate = () => moment().format("MM/DD/YYYY");

export const dateToString = (date: any) => {
  const formattedDate = moment(date).format("MM/DD/YYYY");
  return formattedDate;
};

const dateToString2 = (date: any, timeZoneOffset: any) => {
  if (timeZoneOffset) {
    const formattedDate = moment(date)
      ?.utcOffset(timeZoneOffset)
      .format("MM/DD/YYYY");
    return formattedDate;
  }
};

export const stringToDateObject = (dateString: any) => {
  const dateObject = moment(dateString).toDate();
  return dateObject;
};

export const string1ToDateObject = (dateString: any) => {
  const dateObject = moment(dateString, "YYYY-MM-DD").toDate();
  return dateObject;
};

const addDayToDateObject = (date: any) => {
  const newDate = date;
  newDate.setDate(newDate.getDate() + 1);
  return newDate;
};

const trimLabel = (fileName: any, size: any) => {
  return fileName?.substring(0, size);
};

export const isEndSoon = ({
  date,
  frequency,
  intervalCount,
  intervalSelector,
}: {
  date: any;
  frequency:string;
  intervalCount: number;
  intervalSelector: string;
}) => {
  if (!date) return false;

  const currentDate = moment();
  const endDate = moment(date);
  let difference = -1;

  switch (frequency) {
    case "daily":
      difference = endDate.diff(currentDate, "days");
      break;
    case "weekly":
      difference = endDate.diff(currentDate, "weeks");
      break;
    case "monthly":
      difference = endDate.diff(currentDate, "months");
      break;
    case "yearly":
      difference = endDate.diff(currentDate, "years");
      break;
    case "semiannually":
      difference = endDate.diff(currentDate, "months") / 6;
      break;
    case "quarterly":
      difference = endDate.diff(currentDate, "months") / 3;
      break;
    case "custom":
      if (intervalSelector === "day") {
        difference = endDate.diff(currentDate, "days") / intervalCount;
      } else if (intervalSelector === "week") {
        difference = endDate.diff(currentDate, "weeks") / intervalCount;
      } else if (intervalSelector === "month") {
        difference = endDate.diff(currentDate, "months") / intervalCount;
      } else if (intervalSelector === "year") {
        difference = endDate.diff(currentDate, "years") / intervalCount;
      }
      break;
    default:
      return false;
  }

  return difference <= 1;
};

export const isCacelledBefore = (canceled_date: any, end_date: any) => {
  if (!canceled_date || !end_date) return false;
  const endDate = moment(end_date);
  const cancelDate = moment(canceled_date);
  return cancelDate.isSameOrBefore(endDate, "days");
};

export const isEnded = (date: any) => {
  if (!date) return false;
  const currentDate = moment();
  const endDate = moment(date);
  return currentDate.isAfter(endDate, "days");
};

export const isCancelsSoon = (date: any) => {
  if (!date) return false;
  const currentDate = moment();
  const cancelDate = moment(date);
  return cancelDate.isAfter(currentDate, "days");
};
